import React, { createContext, useState, useContext, useEffect } from 'react'

export const PageContext = createContext(null)

export const usePageContext = () => useContext(PageContext)

export default function PageContextProvider({ children, pageType = null, isParent = true }) {
  const [pageContext, setPageContext] = useState({ pageType, isParent })
  
  useEffect(() => {
    setPageContext({ pageType, isParent })
  }, [pageType, isParent])
  
  return (
    <PageContext.Provider value={{ pageContext, setPageContext }}>
      {children}
    </PageContext.Provider>
  )
}
